import { lazy } from "react";

export const Dashboard = lazy(() => import("../pages/Dashboard"));
export const Delegate = lazy(() => import("../pages/delegates/Delegate"));
export const DelegateCreate = lazy(
  () => import("../pages/delegates/DelegateCreate"),
);
export const DelegateUpdate = lazy(
  () => import("../pages/delegates/DelegateUpdate"),
);
export const Excels = lazy(() => import("../pages/excels/Excels"));
export const ExcelsCreate = lazy(() => import("../pages/excels/ExcelsCreate"));
export const ExcelsUpdate = lazy(() => import("../pages/excels/ExcelsUpdate"));
export const Hotel = lazy(() => import("../pages/hotel/Hotel"));
export const HotelCreate = lazy(() => import("../pages/hotel/HotelCreate"));
export const HotelUpdate = lazy(() => import("../pages/hotel/HotelUpdate"));
export const Event = lazy(() => import("../pages/event/Event"));
export const EventCreate = lazy(() => import("../pages/event/EventCreate"));
export const EventUpdate = lazy(() => import("../pages/event/EventUpdate"));
